
define(
    'Facets.FacetedNavigationItem.View.Extension',
    [
        'facets_faceted_navigation_item_categories_menu_tree_extension.tpl',

        'Facets.FacetedNavigationItem.View',
        'underscore',
        'Utils'
    ],
    function(
        facets_faceted_navigation_item_categories_menu_tree_extension_tpl,

        FacetsFacetedNavigationItemView,
        _,
        Utils

    ) {
        'use strict';

        _.extend(FacetsFacetedNavigationItemView.prototype, {

            

            events: _.extend(FacetsFacetedNavigationItemView.prototype.events, {
                'click [data-name="category_checkbox"]': 'navigateToSubCategory'
            }),

            navigateToSubCategory : function(e){
                
                var categoryUrl = this.$(e.target).data("url");
                
                var cathInternalId = this.$(e.target).data("catpath");
                var catPath = "cat_path_" + cathInternalId;
                
                // target url to navigate
                // var targetUrl = this.options.translator.cloneForFacetId(catPath, categoryUrl).getUrl();
                var targetUrlTranslator = this.options.translator.cloneForFacetId(catPath, categoryUrl);

                var currentUrl = this.options.translator.getUrl();


                 // currentUrl can contain other "cat_path_" elements
                
                var urlOptions = _.parseUrlOptions(currentUrl);

                var previousUrlOption = "";
           
                _.each(urlOptions, function (value, key) {
                    if (key.indexOf("cat_path_")!= "-1"){
                        previousUrlOption = key
                    }
                });

                
                if (previousUrlOption){
                    // Remove the old cat_path_ from the targe transaltor intance
                    
                    targetUrlTranslator.facets = _.without(targetUrlTranslator.facets, _.findWhere(targetUrlTranslator.facets, {
                        id: previousUrlOption
                      }));

                }
                Backbone.history.navigate(targetUrlTranslator.getUrl() ,{ trigger:true })


                


            },


            configurateCategoriesFacets : function(context){
                
                var self = this;
                if (this.model.get("url")) {
                    if (this.model.get("url").indexOf("cat_path_")!= -1)  {
                        this.template = facets_faceted_navigation_item_categories_menu_tree_extension_tpl
                    }
                }
            },
            
            
           getContext: _.wrap(FacetsFacetedNavigationItemView.prototype.getContext, function (fn) {
               
                
                var context = fn.apply(this, _.toArray(arguments).slice(1));
                
                this.configurateCategoriesFacets(context);
                return context;
            }),

            

           
        });
    });
